function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkeleton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 96,
    viewBox: "0 0 102 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8927 81.0822C6.75149 76.3547 3.79607 71.0724 1.92872 65.1232C0.0221463 59.049 -0.410729 52.8674 0.365275 46.6225C1.28105 39.2526 4.00715 32.5428 8.45192 26.5642C8.47289 26.536 8.49549 26.5083 8.52103 26.4843C10.2179 24.8913 10.5283 23.0751 10.1655 20.7284C9.33623 15.3649 8.99451 9.93544 9.45462 4.49585C9.51949 3.72896 9.68628 2.96529 9.86705 2.21491C10.17 0.957339 10.8351 0.460108 12.0278 0.929257C14.2412 1.79999 16.5178 2.64134 18.5178 3.89549C21.9058 6.02005 25.0843 8.47783 28.3934 10.733C28.8067 11.0147 29.5419 11.1172 30.0197 10.9639C34.6929 9.46524 39.4759 8.80702 44.3716 8.91503C48.5486 9.00719 52.6383 9.64007 56.5952 11.0075C57.3603 11.2719 57.8854 11.1121 58.5043 10.6069C62.7677 7.127 67.2688 4.00254 72.2909 1.7004C73.0207 1.36588 73.8036 1.12917 74.5821 0.923985C75.913 0.573231 76.6428 0.928272 76.7928 2.26161C77.1028 5.01769 77.4474 7.79713 77.3934 10.5594C77.3385 13.3644 77.029 16.2029 76.4671 18.9522C74.7075 27.5631 71.2383 35.3548 64.9589 41.6948C64.1272 42.5346 63.9521 42.5101 63.3982 41.4487C58.6125 32.2787 47.5605 27.464 37.5488 30.2405C30.273 32.2583 25.1408 36.7613 22.2272 43.7602C17.4448 55.2481 23.0974 68.7835 34.722 73.4488C39.6078 75.4096 44.5471 75.6193 49.6228 74.411C54.6295 73.2192 58.5664 70.273 62.2352 66.862C65.5543 63.7761 68.633 60.3968 72.6587 58.1674C77.3046 55.5946 82.1908 54.194 87.5474 55.2733C93.359 56.4441 97.4673 59.8555 99.894 65.168C100.889 67.3459 101.309 69.7876 101.983 72.1114C102.019 72.2351 101.987 72.3783 101.987 72.7163C101.014 72.4414 100.132 72.1925 99.25 71.9428C92.7821 70.1116 86.9633 71.5095 81.8707 75.7422C79.3896 77.8044 77.2011 80.2193 74.8757 82.47C70.2222 86.9741 64.9693 90.5798 58.9037 92.8909C50.8698 95.9519 42.6262 96.5443 34.2165 94.7418C24.9716 92.7602 17.2413 88.1778 10.8927 81.0822Z",
    fill: "url(#paint0_linear_4150_11234)",
    style: {}
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4150_11234",
    x1: 71.7302,
    y1: 0.755371,
    x2: 71.7302,
    y2: 92.8908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A377FF",
    style: {
      stopColor: "#A377FF",
      stopColor: "color(display-p3 0.6378 0.4686 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48278F",
    style: {
      stopColor: "#48278F",
      stopColor: "color(display-p3 0.2815 0.1511 0.5608)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkeleton);
export default __webpack_public_path__ + "static/media/skeleton.aa6d85eed9d0bb68708fbeb38983f277.svg";
export { ForwardRef as ReactComponent };